import { render } from "./SpacingDemo.vue?vue&type=template&id=228ea0e2&scoped=true"
import script from "./SpacingDemo.vue?vue&type=script&lang=js"
export * from "./SpacingDemo.vue?vue&type=script&lang=js"

import "./SpacingDemo.vue?vue&type=style&index=0&id=228ea0e2&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/eAzC_LUi/0/econsultingsistemas/certificadorweb/certificador-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-228ea0e2"]])

export default __exports__